/**
 *
 * Asynchronously loads the component for MoveApplicantPopup
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
